import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IMedia } from '@epicuro-next/ataraxia/models';
import { dynamicElementsSlidingCarouselKey } from '@epicuro-next/constants/dynamic-elements';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { register } from 'swiper/element/bundle';
import { A11y, Navigation } from 'swiper/modules';

import { SimpleBannerComponent } from '../simple-banner/simple-banner.component';

import { SwiperDirective } from './swiper.directive';

export type SlidingCarouselSlide = {
  media: IMedia;
  title: string;
  subtitle: string;
  routerLink: string;
};

export type SlidingCarouselSlides = SlidingCarouselSlide[];

@DynamicComponentRegister(dynamicElementsSlidingCarouselKey, true)
@Component({
  selector: 'atx-sliding-carousel',
  templateUrl: './sliding-carousel.component.html',
  styleUrls: ['./sliding-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SimpleBannerComponent, SwiperDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SlidingCarouselComponent {
  @Input() public set slides(value: SlidingCarouselSlides | string) {
    if (typeof value === 'string' || value instanceof String) {
      this.slidesParsed = JSON.parse(value as string)
        .slides as SlidingCarouselSlides;
    } else {
      this.slidesParsed = value as {
        media: IMedia;
        title: string;
        subtitle: string;
        routerLink: string;
      }[];
    }
  }

  @Input() public set figureMaxWidth(maxWidth: number) {
    if (maxWidth) {
      this.hostEl.nativeElement.style.setProperty(
        '--simple-banner-figure-width',
        `${maxWidth}`,
      );
    }
  }

  @Input() public disabledRouterLink = false;

  @Output() public slideRedirectClick =
    new EventEmitter<SlidingCarouselSlide>();

  public slidesParsed: SlidingCarouselSlides;

  public config = {
    modules: [Navigation, A11y],
    navigation: true,
    spaceBetween: 0,
    loop: true,
    lazyPreloadPrevNext: 2,
    autoplay: {
      delay: 100000,
    },
  };

  public videoPlayerProps = {
    autoplay: true,
    controls: false,
    muted: true,
    volume: 1,
  };

  constructor(private hostEl: ElementRef<HTMLElement>) {
    register();
  }
}
